import { auth } from "./InitFirebase";
// Import the functions you need from the SDKs you need
import { signInWithPopup, GithubAuthProvider, GoogleAuthProvider, createUserWithEmailAndPassword, updateProfile, signInWithEmailAndPassword, sendEmailVerification, 
  sendPasswordResetEmail
} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries





export const signInWithGithub = (navigate) => {
  return signInWithPopup(auth, new GithubAuthProvider())
    .then((result) => {
      // This gives you a GitHub Access Token. You can use it to access the GitHub API.
      const credential = GithubAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;

      // The signed-in user info.
      const user = result.user;
      // IdP data available using getAdditionalUserInfo(result)
      // ...
      console.log("[SUCCESS] GitHub User: ", user);
      navigate("/");  
      return {code: 200, result: "success"}
    }).catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GithubAuthProvider.credentialFromError(error);
      // ...
      console.log("[ERROR] Failed to sign - with github", error.message)
      return {code: 400, result: error.message}
    })
}
export const signInWithGoogle = (navigate) => {
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access the Google API.
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    // The signed-in user info.
    const user = result.user;
    // IdP data available using getAdditionalUserInfo(result)
    // ...
    console.log("[SUCCESS] Google User: ", user);
    navigate("/");  
    return {code: 200, result: "success"}
  })
  .catch((error) => {
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    console.log("[ERROR] Failed to sign - with google", error.message);
    return {code: 400, result: error.message}
  })
}
export const signUpWithEmail = (navigate, email, password) => {
  return createUserWithEmailAndPassword(auth, email, password)
    .then(async (userCredential) => {
      const user = userCredential.user;
      await updateProfile(auth.currentUser, { //If user sings up with email, the first part of their email becomes the diplay name
        displayName:  email.substring(0, email.indexOf("@"))
      })
      console.log("[SUCCESS] Email User: ", user);
      await sendEmailVerification(user);
      await signOut(auth);
      console.log("[SUCCESS] Verification email sent to:", user.email);

      // navigate("/Profile");  
      return {code: 300, result: "A confirmation email has been sent to the provided email, please confirm before logging in."}
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log("[ERROR] Failed to sign (up/in) with email", error.message);
      return {code: 400, result: error.message}
    });
}

export const signInWithEmail = (navigate, email, password) => {
    return signInWithEmailAndPassword(auth, email, password)
    .then(async (userCredential) => {
      // Signed in
      var user = userCredential.user;
      if(!user.emailVerified){
        await signOut(auth);
        return {code: 300, result: "A confirmation email has been sent to the provided email, please confirm before logging in."}
      }

      console.log("[SUCCESS] Email User: ", user);
      navigate("/");  
      return {code: 200, result: "success"}
      // ...
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log("[ERROR] Failed to sign (up/in) with email", error.message);
      return {code: 400, result: error.message}
    });
}

export const sendPasswordResetLink = async (userEmail) => {
  try {
    await sendPasswordResetEmail(auth, userEmail);
    console.log("[SUCCESS] Password reset email sent to:", userEmail);
    return { code: 200, result: "Password reset email sent successfully." };
  } catch (error) {
    console.error("[ERROR] Failed to send password reset link:", error.message);
    return { code: 400, result: error.message };
  }
};



export const signOut = () =>{
  auth.signOut().then(function() {
      console.log('Signed Out');
    }, function(error) {
      console.error('Sign Out Error', error);
    });
}


